import { styled } from "@mui/material/styles";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import { Link } from "react-router-dom";
import theme from "../theme";
import SearchBarProfile from "../Components/SearchBarProfile";
import NotificationsIcon from "@mui/icons-material/Notifications";
import { useState } from "react";
import Notifications from "../Notifications/Notifications";
import { useUser } from "../UserContext";

const Search = styled("div")(({ theme }) => ({
  position: "absolute",
  right: "60px",
  borderRadius: theme.shape.borderRadius,
  width: "100%",
  marginLeft: theme.spacing(1.6),
  [theme.breakpoints.up("sm")]: {
    width: "auto",
  },
}));

interface AppBarProps {
  isExpanded: boolean;
  toggleSidebar: () => void;
}

export default function SearchAppBar({
  isExpanded = true,
  toggleSidebar,
}: AppBarProps) {
  const [notificationsOpen, setNotificationsOpen] = useState<boolean>(false);
  const { currentUser } = useUser();

  const handleNotificationsToggle = () => {
    setNotificationsOpen((prev) => !prev);
  };

  const handleClose = () => {
    setNotificationsOpen(false);
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar
        position="fixed"
        sx={{
          borderWidth: 0,
          borderBottomWidth: 1,
          borderStyle: "solid",
          boxShadow: "none",
          zIndex: theme.zIndex.drawer + 1,
          backgroundColor: (theme) => theme.palette.custom.sidebar,
        }}
      >
        <Toolbar>
          <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="open drawer"
            sx={{ mr: 2 }}
            onClick={toggleSidebar}
          >
            {isExpanded ? <MenuOpenIcon /> : <MenuIcon />}
          </IconButton>
          <Link to="/">
            <img
              src="https://media.promoraven.com/app/logo/Raven-White.png"
              alt="Promo Raven Logo"
              style={{ width: "80%", maxWidth: "20px", marginRight: "10px" }}
            />
            <img
              src="https://media.promoraven.com/app/logo/Raven-Text-White.png"
              alt="Promo Raven Logo"
              style={{ width: "80%", maxWidth: "125px" }}
            />
          </Link>
          {currentUser && (
            <Search style={{ zIndex: 1 }}>
              <SearchBarProfile />
            </Search>
          )}
          <Box
            sx={{
              marginLeft: "auto",
              marginBottom: "4px",
              cursor: "pointer",
              zIndex: 10,
            }}
          >
            {currentUser && (
              <NotificationsIcon onClick={handleNotificationsToggle} />
            )}
          </Box>
        </Toolbar>
      </AppBar>
      {currentUser && (
        <Notifications open={notificationsOpen} handleClose={handleClose} />
      )}
    </Box>
  );
}
